import { render, staticRenderFns } from "./lightbox-urls.vue?vue&type=template&id=33906ab0&scoped=true&"
import script from "./lightbox-urls.vue?vue&type=script&lang=js&"
export * from "./lightbox-urls.vue?vue&type=script&lang=js&"
import style0 from "./lightbox-urls.vue?vue&type=style&index=0&id=33906ab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33906ab0",
  null
  
)

export default component.exports